import Main from '../../layouts/Main';
import Container from '../../components/Container';
import {Box} from '@mui/material';
import PageBreadcrumbs from '../../components/PageBreadcrumbs';
import { TrainingCourses } from '../Home1/components';

const TreasurerTrainings = (): JSX.Element => {

  return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Box marginBottom={3}></Box>
        <TrainingCourses></TrainingCourses>
      </Container>
    </Main>
  );
};

export default TreasurerTrainings;